import React, { useState, useEffect } from "react";
import TableComponent from "../../../Common/TableComponent/tableComponent";
import { TableLoader } from "../../../Common/ShimmerLoader";
import { useLocation, useNavigate } from "react-router-dom";
import CustomDataTable from "../../../Common/ReportTable/ReportTable";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";

const ScvCircleInnerAllotedVehicleRcv = () => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const data = location.state;
  const navigate = useNavigate();

  const scvReportColumns = [
    {
      name: "S.No",
      selector: (row) => row["sno"],
      sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
    },
    {
      name: "Zone",
      selector: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["zoneName"] || "N/A"}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Circle",
      selector: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["circleName"] || "N/A"}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Ward",
      selector: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["wardName"] || "N/A"}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Deployment Date",
      selector: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        //   onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["deploymentDate"] || "N/A"}
        </span>
      ),
      sortable: true,
    },
    {
      name: "No. Of Helpers",
      selector: (row) => (
        <span
        >
          {row["numberOfHelpers"]}
        </span>
      ),
      sortable: true,
    },
    // {
    //   name: "Is LoadingEquipment Tagged",
    //   selector: (row) => (
    //     <span
    //     >
    //       {row["isLoadingEquipmentTagged"]}
    //     </span>
    //   ),
    //   sortable: true,
    // },
    // {
    //   name: "LoadingEquipment Number",
    //   selector: (row) => (
    //     <span
    //     // style={{ color: "blue", cursor: "pointer" }}
    //     >{row["loadingEquipmentNumber"]}</span>
    //   ),
    //   sortable: true,
    // },
    {
      name: "Driver Name",
      selector: (row) => (
        <span > {row["driverName"] || "N/A"}</span>
      ),
      sortable: true,
    },
    {
      name: "Driver Mobile",
      selector: (row) => (
        <span > {row["mobileNumber"] || "N/A"}</span>
      ),
      sortable: true,
    },
    {
      name: "Owner Type",
      selector: (row) => (
        <span > {row["ownerTypeName"] || "N/A"}</span>
      ),
      sortable: true,
    },
    {
      name: "Route Code",
      selector: (row) => (
        <span > {row["routeCode"] || "N/A"}</span>
      ),
      sortable: true,
    },
    {
      name: "Scanned Latitude",
      selector: (row) => (
        <span > {row["scannedLatitude"] || "N/A"}</span>
      ),
      sortable: true,
    },
    {
      name: "Scanned Longitude",
      selector: (row) => (
        <span > {row["scannedLongitude"] || "N/A"}</span>
      ),
      sortable: true,
    },
    {
      name: "Deployment Details Id",
      selector: (row) => (
        <span > {row["secondaryDeploymentDetailsId"] || "N/A"}</span>
      ),
      sortable: true,
    },
    {
      name: "Deployment Incharge Attendance Id",
      selector: (row) => (
        <span > {row["secondaryDeploymentInchargeAttendanceId"] || "N/A"}</span>
      ),
      sortable: true,
    },

    {
      name: "Deployment Incharge",
      selector: (row) => (
        <span > {row["secondaryDeploymentInchargeName"] || "N/A"}</span>
      ),
      sortable: true,
    },
    {
      name: "Shift",
      selector: (row) => (
        <span > {row["shiftName"] || "N/A"}</span>
      ),
      sortable: true,
    },
    {
      name: "Vehicle Number",
      selector: (row) => (
        <span > {row["vehicleNumber"] || "N/A"}</span>
      ),
      sortable: true,
    },
    {
      name: "Vehicle Uid",
      selector: (row) => (
        <span > {row["vehicleUuid"] || "N/A"}</span>
      ),
      sortable: true,
    },
    {
      name: "Deployment Image",
      cell: (row) => {
        if (row["vehicleImageUrl"]) {
          return (
            <img
              src={row["vehicleImageUrl"]}
              alt="Vehicle"
              style={{ maxWidth: "100px", maxHeight: "100px" }}
            />
          );
        } else {
          return <span >No image</span>;
        }
      },
      sortable: true,
    },
  ];

  // const downloadAsExcel = () => {
  //   if (!data) return; // Check if data is initialized
  //   // Add serial number to each item in the collection details
  //   const dataWithSerialNumber = data.map((item, index) => ({
  //     ...item,
  //     's.no': index + 1,
  //   }));
  
  //   // Filter out only the data corresponding to the headers displayed in the table component
  //   const filteredData = dataWithSerialNumber.map(item => ({
  //     's.no': item['s.no'],
  //     zone: item.zoneName,
  //     circle: item.circleName,
  //     ward: item.wardName,
  //     DeploymentDate:item.deploymentDate,
  //     NoOfHelpers:item.numberOfHelpers,
  //     DriverName:item.driverName,
  //     MobileNumber:item.mobileNumber,
  //     OwnerTypeName:item.ownerTypeName,
  //     RouteCode:item.routeCode,
  //     ScannedLatitude:item.scannedLatitude,
  //     ScannedLongitude:item.scannedLongitude,
  //     SDDetailsId:item.secondaryDeploymentDetailsId,
  //     SDIName:item.secondaryDeploymentInchargeName,
  //     ShiftName:item.shiftName,
  //     VehicleNumber:item.vehicleNumber,
  //     VehicleUid:item.vehicleUuid
  //   }));
  
  //   const ws = XLSX.utils.json_to_sheet(filteredData);
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "SCVsInnerClearnceReport");
  //   const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  //   const excelBlob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
  //   const downloadLink = document.createElement("a");
  //   downloadLink.href = URL.createObjectURL(excelBlob);
  //   downloadLink.download = "SCVsInnerClearnceReport.xlsx";
  //   downloadLink.click();
  // };

  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `MultiClearanceInnerExistingReport`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");

    // Define styles
    const boldFont = { bold: true };

    // Add row for download date and time
    const downloadDateTime = `Reported on: ${formattedDate} ${formattedTime}`;
    const dateTimeRow = worksheet.addRow(["", "", downloadDateTime, "", ""]);
    worksheet.mergeCells(1, 3, 1, 5); 
    dateTimeRow.getCell(3).font = boldFont; // Set style for the cell
    dateTimeRow.getCell(3).alignment = { horizontal: "center" }; // Center align the cell content
    dateTimeRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber >= 3 && colNumber <= 5) {
            // Apply styles to download date and time cells
            cell.font = boldFont;
            cell.alignment = { horizontal: "center" };
        }
    });

    // Add row for cumulative heading report
    const cumulativeHeadingRow = worksheet.addRow(["", "", cumulativeHeadingReport, "", ""]);
    worksheet.mergeCells(2, 3, 2, 5);
    cumulativeHeadingRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber >= 3 && colNumber <= 5) {
            // Apply styles to cumulative heading report cells
            cell.font = boldFont;
            cell.alignment = { horizontal: "center" };
        }
    });

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
        "S.No",
        "Zone",
        "Circle",
        "Ward",
        "PointName",
        "Latitude",
        "Longitude",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.font = boldFont;
        cell.alignment = { horizontal: "left" }; // Left align the cell content
        if (colNumber >= 1 && colNumber <= 12) {
            // Apply background color only to specific cells
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFFF0000" } // Red background color
            };
        }
    });

    // Add data rows
    data.forEach((item, index) => {
        worksheet.addRow([
            index + 1,
            item.zoneName?? "N/A",
            item.circleName?? "N/A",
            item.wardName?? "N/A",
            item.collectionPointName?? "N/A",
            item.latitude?? "N/A",
            item.longitude?? "N/A",
        ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
            if (colNumber >= 1 && colNumber <= 12) {
                // Align the columns from 1 to 4 to the left
                cell.alignment = { horizontal: "left" };
            } else {
                // Align the rest of the columns to the center
                cell.alignment = { horizontal: "center" };
            }
        });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
        { width: 5 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Multi Clearace Inner Existing Report.xlsx";
    a.click();
    URL.revokeObjectURL(url);
};



  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="top-header page-title">
              <span>{" "}
                    SCVs Repoted at Circle</span>
            </div>
            <div className="page-header">
            <div className="card mt-3">
              <div className="card-body">
            <div className="d-flex justify-content-end mt-3 mb-3">
              <button className="btn btn-secondary me-2"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
              <button
                className="btn btn-excel"
                onClick={downloadAsExcel}
              >
             <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
              </button>
            </div>
         

                <CustomDataTable data={data} columns={scvReportColumns} />
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// Function to get default date in "YYYY-MM-DDTHH:MM" format
const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
};

export default ScvCircleInnerAllotedVehicleRcv;
